import Overview from '@rebuild/materials/shared/custom/Overview.vue';
import Full from '@rebuild/materials/shared/custom/Full.vue';

export const componentMap = {
	overview: Overview,
	full: Full
};
